import { getIn } from 'formik';

export const getErrorFormik = (errors: any, touched: any, sectionKey: string, field: string) => {
  if (!errors || !touched || !Object.keys(errors).length) {
    return false;
  }

  const fieldPath = `${sectionKey}.${field}`;
  const fieldError = getIn(errors, fieldPath);
  const fieldTouched = getIn(touched, fieldPath);

  return fieldError && fieldTouched;
};
